
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Avatar } from "baseui/avatar";
import { StatefulPopover, PLACEMENT } from 'baseui/popover';
import { StatefulMenu } from 'baseui/menu';
import { Button, KIND, SHAPE } from 'baseui/button';
import { useGetUserQuery } from '../../services/msgraph/msGraphApi'
import { useGetLanguage } from '../../hooks/useGetLanguage'
import { msalInstance } from "../..";
import { useFlutterAppInterface } from "../../hooks/useFlutterAppInterface"
import { useDeleteDeviceRegistrationMutation } from '../../services/notifications/notificationsApi'
import { toaster } from 'baseui/toast';
import { useNavigate } from "react-router-dom";
import { getAccount } from "../../msalConfig"

export function CurrentUserAvatar() {
  const { instance, accounts, inProgress } = useMsal();
  const nav = useNavigate();
  const { data, isLoading, isSuccess, error } = useGetUserQuery();
  const { language } = useGetLanguage();
  var myAccount = getAccount(accounts);


  const [items, setItems] = useState([
    { label: myAccount?.name, action: gotoUserDetails, disabled: !data?.id },
    { divider: true },
    { label: 'Logout', action: signOutClickHandler, disabled: false },
  ])
  const { deviceId } = useFlutterAppInterface();
  const [deleteDeviceReg, deleteDeviceRegResult] = useDeleteDeviceRegistrationMutation();

  const name = myAccount?.name;


  useEffect(() => {
    if (data) {
      setItems((prevState) => {
        const old = [...prevState];
        old[0].label = data.displayName;
        old[0].disabled = false;
        return old;
      })
    }
  }, [data]);

  function gotoUserDetails() {
    nav(`/users/me`)
  }


  async function signOutClickHandler() {
    await doDeleteDeviceReg();
    await instance.logoutRedirect();//.logoutPopup();
  }

  async function doDeleteDeviceReg() {
    // TODO: never works since account is already logged out
    if (!msalInstance.getActiveAccount())
      return;

    if (deviceId) {
      console.debug("[CurrentUserAvatar.jsx] - remove deviceRegistration", deviceId)
      await deleteDeviceReg(deviceId);
    }
  }

  useEffect(() => {
    if (deleteDeviceRegResult.isError) {
      console.error('[CurrentUserAvatar.jsx] - error Device un-register for Push Notifications', JSON.stringify(deleteDeviceRegResult.error))
      toaster.negative('Error un-register device.\n' + JSON.stringify(deleteDeviceRegResult.error), {
        autoHideDuration: 5000, overrides: {
          InnerContainer: {
            style: { width: "100%" }
          }
        }
      })
    }
    else if (deleteDeviceRegResult.isSuccess) {
      console.info('[CurrentUserAvatar.jsx] - Device un-registered for Push Notifications', deviceId)
      toaster.info(`Device un-registered for Push Notifications`, {
        autoHideDuration: 5000, overrides: {
          InnerContainer: {
            style: { width: "100%" }
          }
        }
      })
    }
  }, [deleteDeviceRegResult])

  function onSelect(args,close) {
    close();
    args.item.action();
    
  }

  const username = data ? data.displayName : name;
  return (

    <StatefulPopover
      focusLock
      placement={PLACEMENT.bottomLeft}
      content={({ close }) => (
        <StatefulMenu
          items={items}
          onItemSelect={(args) => onSelect(args,close)}
        /*overrides={{
            List: { style: { height: '150px', width: '138px' } },
        }}*/
        />
      )}
    >
      <Button kind={KIND.tertiary} shape={SHAPE.circle} >
        <Avatar
          name={username}
          size="scale1000"
        //src={userImageUrl}
        />
      </Button>
    </StatefulPopover>

  );
};